import { ColumnState } from "ag-grid-community"
import { ISearchQueryRequest } from "../models/ISearchQueryRequest"

export const updateSortFieldRequest = (updateRequest: ISearchQueryRequest, sortCol: ColumnState, fieldName: string) => {
    updateRequest = {
        ...updateRequest, sort: {
            field: fieldName,
            order: getStatusSort(sortCol.sort)
        }
    }
    return updateRequest
}

//This have to fill exactly data
export const uniqueFilterRequest = (updateRequest: ISearchQueryRequest, data:any, key:string, checked:boolean) =>{
    if(checked){
        const fixedField = {[key] : data}
        updateRequest = {
            ...updateRequest, 
            ...fixedField
            }
    }else{
        const fixedField = {[key] : undefined}
        updateRequest = {
            ...updateRequest, 
            ...fixedField
        }
        delete (updateRequest as any)[key]
    }
    return updateRequest;
}

const getStatusSort = (iType:string | null |undefined) => {
    switch(iType){
        case "asc":
            return "Ascending"
        case "desc":
            return "Descending"
        default:
            return "none"
    }
}

export const wrapperDataReturnDataForUnitTest = (e:any) =>{
    return e;
}